export const UpdateTitle = (newTitle) => {
  return (document.title = newTitle);
};
